<template>
  <div class="container" style="margin-bottom: 10px">
    <div class="card" style="padding: 16px">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div>
          <h5 style="margin: 0">Pruebas de correo</h5>
          <p style="margin: 0; font-size: 12px; color: #7c7c7c">
            Envío a endpoint con headers manuales.
          </p>
        </div>
        <div class="d-flex gap-2" style="margin-top: 8px">
          <button class="btn btn-outline-secondary btn-sm" @click="resetForm">
            Reset
          </button>
          <button
            class="btn btn-success btn-sm"
            @click="onEnviar"
            :disabled="sending"
          >
            {{ sending ? "Enviando..." : "Enviar" }}
          </button>
        </div>
      </div>

      <hr style="margin: 12px 0" />

      <div class="card" style="padding: 12px; border: 1px solid #eee">
        <h6 style="margin: 0">Endpoint y headers (solo pruebas)</h6>
        <p style="margin: 8px 0 0 0; font-size: 12px; color: #7c7c7c">
          Pegar tokens en el front <strong>nunca</strong> es buena práctica en
          producción (quedan en memoria del navegador y pueden filtrarse). Para
          <strong>admin local</strong> o entorno de prueba controlado está bien;
          no subas capturas ni commits con valores reales.
        </p>

        <div class="row" style="margin-top: 8px">
          <div class="col-12">
            <label class="form-label">Endpoint URL (completa, opcional)</label>
            <input
              class="form-control"
              v-model="endpointUrl"
              type="text"
              autocomplete="off"
              :placeholder="defaultProxyPlaceholder"
            />
            <small style="color: #7c7c7c">
              Vacío = mismo host que usa el resto de la app (emulador :5001 o
              prod), no
              <code>localhost:8081</code>.
            </small>
          </div>
        </div>

        <div class="row" style="margin-top: 8px">
          <div class="col-12">
            <label class="form-label"
              >Authorization — JWT del servicio Saludsa (sin “Bearer ”)</label
            >
            <div class="d-flex gap-2 align-items-start flex-wrap">
              <input
                class="form-control flex-grow-1"
                style="min-width: 220px"
                v-model="authorizationToken"
                :type="showSaludsaToken ? 'text' : 'password'"
                autocomplete="off"
                spellcheck="false"
                placeholder="eyJhbGciOi..."
              />
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                style="margin-top: 0"
                @click="showSaludsaToken = !showSaludsaToken"
              >
                {{ showSaludsaToken ? "Ocultar" : "Mostrar" }}
              </button>
            </div>
            <small style="color: #7c7c7c">
              El proxy lee estos headers y los reenvía tal cual al API de
              Saludsa:
              <code>Authorization</code>, <code>CodigoAplicacion</code>,
              <code>CodigoPlataforma</code>, <code>SistemaOperativo</code>,
              <code>DispositivoNavegador</code>, <code>DireccionIP</code>.
            </small>
          </div>
        </div>

        <hr style="margin: 14px 0" />
        <p style="margin: 0; font-size: 12px; font-weight: 600; color: #333">
          Headers que reenvía el proxy al servicio Saludsa
        </p>

        <div class="row" style="margin-top: 8px">
          <div class="col-12 col-md-3">
            <label class="form-label">CodigoAplicacion</label>
            <input
              class="form-control"
              v-model="headers.CodigoAplicacion"
              type="text"
              inputmode="numeric"
              autocomplete="off"
              placeholder="Ej: 13"
            />
          </div>
          <div class="col-12 col-md-3">
            <label class="form-label">CodigoPlataforma</label>
            <input
              class="form-control"
              v-model="headers.CodigoPlataforma"
              type="text"
              inputmode="numeric"
              autocomplete="off"
              placeholder="Ej: 1"
            />
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label">SistemaOperativo</label>
            <input
              class="form-control"
              v-model="headers.SistemaOperativo"
              type="text"
              autocomplete="off"
              placeholder="Ej: macOS 14.6.0"
            />
          </div>
        </div>

        <div class="row" style="margin-top: 8px">
          <div class="col-12 col-md-6">
            <label class="form-label">DispositivoNavegador</label>
            <input
              class="form-control"
              v-model="headers.DispositivoNavegador"
              type="text"
              autocomplete="off"
              placeholder="Se rellena con el user-agent; ajústalo si quieres"
            />
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label">DireccionIP</label>
            <input
              class="form-control"
              v-model="headers.DireccionIP"
              type="text"
              autocomplete="off"
              placeholder="Tu IP pública o la que deba ver el backend"
            />
          </div>
        </div>

        <div v-if="lastResult" style="margin-top: 10px">
          <small style="color: #7c7c7c">Último resultado</small>
          <div
            class="card"
            style="padding: 10px; border: 1px solid #eee; margin-top: 6px"
          >
            <div class="d-flex gap-2 flex-wrap">
              <span
                class="badge"
                :class="lastResult.ok ? 'bg-success' : 'bg-danger'"
              >
                {{ lastResult.ok ? "OK" : "ERROR" }}
              </span>
              <span class="badge bg-secondary"
                >HTTP {{ lastResult.status }}</span
              >
            </div>
            <pre
              style="
                margin: 8px 0 0 0;
                white-space: pre-wrap;
                word-break: break-word;
              "
              >{{ lastResult.body }}</pre
            >
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6">
          <label class="form-label">Asunto</label>
          <input class="form-control" v-model="form.Asunto" type="text" />
        </div>
        <div class="col-12 col-md-3">
          <label class="form-label">IdAplicacion</label>
          <input class="form-control" v-model="form.IdAplicacion" type="text" />
        </div>
        <div class="col-12 col-md-3">
          <label class="form-label">IdTransaccion</label>
          <input
            class="form-control"
            v-model="form.IdTransaccion"
            type="text"
          />
        </div>
      </div>

      <div class="row" style="margin-top: 12px">
        <div class="col-12 col-md-4">
          <label class="form-label">NumeroIdentificacion</label>
          <input
            class="form-control"
            v-model="form.NumeroIdentificacion"
            type="text"
          />
        </div>
        <div class="col-12 col-md-4">
          <label class="form-label">Contrato</label>
          <input class="form-control" v-model="form.Contrato" type="text" />
        </div>
        <div class="col-12 col-md-4">
          <label class="form-label">TiempoEspera</label>
          <input class="form-control" v-model="form.TiempoEspera" type="text" />
          <small style="color: #7c7c7c">Ej: 1h, 30m, 10s</small>
        </div>
      </div>

      <div class="row" style="margin-top: 12px">
        <div class="col-12 col-md-6">
          <label class="form-label">NombreOrigen</label>
          <input class="form-control" v-model="form.NombreOrigen" type="text" />
        </div>
        <div class="col-12 col-md-6">
          <label class="form-label">EmailOrigen</label>
          <input class="form-control" v-model="form.EmailOrigen" type="email" />
        </div>
      </div>

      <div class="row" style="margin-top: 16px">
        <div class="col-12">
          <div class="d-flex align-items-center justify-content-between">
            <h6 style="margin: 0">Adjuntos</h6>
            <button class="btn btn-outline-primary btn-sm" @click="addAdjunto">
              + Agregar
            </button>
          </div>
          <p style="margin: 6px 0 0 0; font-size: 12px; color: #7c7c7c">
            Cada ítem: Nombre, Contenido (base64 o texto según el API),
            RutaArchivo. Por defecto se envía
            <code>[]</code>
            si no hay filas con datos.
          </p>

          <div
            v-if="form.Adjuntos.length === 0"
            class="text-muted"
            style="margin-top: 8px; font-size: 13px"
          >
            Sin adjuntos. Usa «Agregar» si necesitas uno.
          </div>

          <div
            v-for="(a, idx) in form.Adjuntos"
            :key="`adj-${idx}`"
            class="card"
            style="padding: 12px; margin-top: 10px; border: 1px solid #eee"
          >
            <div class="row">
              <div class="col-12 col-md-4">
                <label class="form-label">Nombre</label>
                <input
                  class="form-control"
                  v-model="a.Nombre"
                  type="text"
                  placeholder="Nombre del archivo"
                />
              </div>
              <div class="col-12 col-md-4" style="margin-top: 8px">
                <label class="form-label">RutaArchivo</label>
                <input
                  class="form-control"
                  v-model="a.RutaArchivo"
                  type="text"
                  placeholder="Ruta o nombre lógico"
                />
              </div>
              <div
                class="col-12 col-md-4 d-flex"
                style="margin-top: 8px; align-items: flex-end; justify-content: flex-end"
              >
                <button
                  class="btn btn-outline-danger btn-sm"
                  type="button"
                  @click="removeAdjunto(idx)"
                  title="Quitar"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
            <div class="row" style="margin-top: 8px">
              <div class="col-12">
                <label class="form-label">Contenido</label>
                <textarea
                  class="form-control"
                  v-model="a.Contenido"
                  rows="3"
                  spellcheck="false"
                  placeholder="Contenido (ej. base64)"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 12px">
        <div class="col-12">
          <label class="form-label">Cuerpo (HTML)</label>
          <textarea
            class="form-control"
            v-model="form.Cuerpo"
            rows="6"
            spellcheck="false"
          ></textarea>
          <div style="margin-top: 8px">
            <small style="color: #7c7c7c">Vista previa rápida</small>
            <div
              class="card"
              style="padding: 12px; margin-top: 6px; border: 1px solid #eee"
              v-html="form.Cuerpo"
            ></div>
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 16px">
        <div class="col-12">
          <div class="d-flex align-items-center justify-content-between">
            <h6 style="margin: 0">EmailsDestino</h6>
            <button class="btn btn-outline-primary btn-sm" @click="addDestino">
              + Agregar
            </button>
          </div>

          <div
            v-for="(d, idx) in form.EmailsDestino"
            :key="`dest-${idx}`"
            class="row"
            style="margin-top: 10px"
          >
            <div class="col-12 col-md-5">
              <input
                class="form-control"
                v-model="d.Nombre"
                type="text"
                placeholder="Nombre"
              />
            </div>
            <div class="col-12 col-md-6" style="margin-top: 8px">
              <input
                class="form-control"
                v-model="d.Direccion"
                type="email"
                placeholder="Direccion"
              />
            </div>
            <div
              class="col-12 col-md-1 d-flex"
              style="margin-top: 8px; justify-content: flex-end"
            >
              <button
                class="btn btn-outline-danger btn-sm"
                @click="removeDestino(idx)"
                :disabled="form.EmailsDestino.length <= 1"
                title="Quitar"
              >
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 16px">
        <div class="col-12">
          <div class="d-flex align-items-center justify-content-between">
            <h6 style="margin: 0">EmailsCopia</h6>
            <button class="btn btn-outline-primary btn-sm" @click="addCopia">
              + Agregar
            </button>
          </div>

          <div
            v-for="(c, idx) in form.EmailsCopia"
            :key="`cc-${idx}`"
            class="row"
            style="margin-top: 10px"
          >
            <div class="col-12 col-md-5">
              <input
                class="form-control"
                v-model="c.Nombre"
                type="text"
                placeholder="Nombre"
              />
            </div>
            <div class="col-12 col-md-6" style="margin-top: 8px">
              <input
                class="form-control"
                v-model="c.Direccion"
                type="email"
                placeholder="Direccion"
              />
            </div>
            <div
              class="col-12 col-md-1 d-flex"
              style="margin-top: 8px; justify-content: flex-end"
            >
              <button
                class="btn btn-outline-danger btn-sm"
                @click="removeCopia(idx)"
                :disabled="form.EmailsCopia.length <= 1"
                title="Quitar"
              >
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 16px">
        <div class="col-12">
          <label class="form-label">Payload (JSON)</label>
          <textarea
            class="form-control"
            :value="payloadPreview"
            rows="10"
            readonly
            spellcheck="false"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getConsultasApiV1BaseURL } from "@/store/axios";

export default {
  name: "PruebasCorreo",
  data() {
    return {
      form: this.getDefaultForm(),
      payloadPreview: "",
      endpointUrl: "",
      authorizationToken: "",
      showSaludsaToken: false,
      headers: this.getDefaultHeaders(),
      sending: false,
      lastResult: null,
    };
  },
  mounted() {
    this.refreshPayloadPreview();
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.refreshPayloadPreview();
      },
    },
  },
  computed: {
    defaultCorreoProxyUrl() {
      const base = getConsultasApiV1BaseURL();
      const normalized = base.endsWith("/") ? base : `${base}/`;
      return `${normalized}testing/CorreoElectronico/EnviarAdjuntos`;
    },
    defaultProxyPlaceholder() {
      return `Vacío → ${this.defaultCorreoProxyUrl}`;
    },
  },
  methods: {
    getDefaultHeaders() {
      const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
      const platform =
        typeof navigator !== "undefined" ? navigator.platform : "";
      return {
        CodigoAplicacion: "",
        CodigoPlataforma: "",
        SistemaOperativo: platform || "",
        DispositivoNavegador: ua || "",
        DireccionIP: "",
      };
    },
    getDefaultForm() {
      return {
        Adjuntos: [],
        Cuerpo: "<table><tr><td>PRUEBA</td></tr></table>",
        Asunto: "Correo de prueba",
        IdAplicacion: "13",
        IdTransaccion: "",
        NumeroIdentificacion: "",
        Contrato: "",
        NombreOrigen: "Comunicaciones",
        EmailOrigen: "comunicaciones@saludsa.com.ec",
        EmailsDestino: [
          { Nombre: "Jaime Morán", Direccion: "jmoran@planproec.com" },
        ],
        EmailsCopia: [
          {
            Nombre: "Jaime Morán Santos",
            Direccion: "jaimemoransantos@gmail.com",
          },
        ],
        TiempoEspera: "1h",
      };
    },
    normalizeEmailRows(rows) {
      return (rows || [])
        .filter((r) => (r?.Direccion || "").trim().length > 0)
        .map((r) => ({
          Nombre: (r?.Nombre || "").trim(),
          Direccion: (r?.Direccion || "").trim(),
        }));
    },
    normalizeAdjuntos(items) {
      return (items || [])
        .filter((x) => {
          const n = (x?.Nombre || "").trim();
          const c = (x?.Contenido || "").trim();
          const r = (x?.RutaArchivo || "").trim();
          return n.length > 0 || c.length > 0 || r.length > 0;
        })
        .map((x) => ({
          Nombre: (x?.Nombre || "").trim(),
          Contenido: (x?.Contenido || "").trim(),
          RutaArchivo: (x?.RutaArchivo || "").trim(),
        }));
    },
    buildPayload() {
      return {
        Adjuntos: this.normalizeAdjuntos(this.form.Adjuntos),
        Cuerpo: this.form.Cuerpo || "",
        Asunto: (this.form.Asunto || "").trim(),
        IdAplicacion: (this.form.IdAplicacion || "").trim(),
        IdTransaccion: (this.form.IdTransaccion || "").trim(),
        NumeroIdentificacion: (this.form.NumeroIdentificacion || "").trim(),
        Contrato: (this.form.Contrato || "").trim(),
        NombreOrigen: (this.form.NombreOrigen || "").trim(),
        EmailOrigen: (this.form.EmailOrigen || "").trim(),
        EmailsDestino: this.normalizeEmailRows(this.form.EmailsDestino),
        EmailsCopia: this.normalizeEmailRows(this.form.EmailsCopia),
        TiempoEspera: (this.form.TiempoEspera || "").trim(),
      };
    },
    refreshPayloadPreview() {
      try {
        this.payloadPreview = JSON.stringify(this.buildPayload(), null, 2);
      } catch (e) {
        this.payloadPreview = "";
      }
    },
    resetForm() {
      this.form = this.getDefaultForm();
      this.refreshPayloadPreview();
      this.lastResult = null;
    },
    addAdjunto() {
      this.form.Adjuntos.push({
        Nombre: "",
        Contenido: "",
        RutaArchivo: "",
      });
    },
    removeAdjunto(idx) {
      this.form.Adjuntos.splice(idx, 1);
    },
    addDestino() {
      this.form.EmailsDestino.push({ Nombre: "", Direccion: "" });
    },
    removeDestino(idx) {
      if (this.form.EmailsDestino.length <= 1) return;
      this.form.EmailsDestino.splice(idx, 1);
    },
    addCopia() {
      this.form.EmailsCopia.push({ Nombre: "", Direccion: "" });
    },
    removeCopia(idx) {
      if (this.form.EmailsCopia.length <= 1) return;
      this.form.EmailsCopia.splice(idx, 1);
    },
    async onEnviar() {
      if (this.sending) return;

      const url = (this.endpointUrl || "").trim();

      const payload = this.buildPayload();
      this.payloadPreview = JSON.stringify(payload, null, 2);

      const token = (this.authorizationToken || "").trim();
      const hdrs = {
        "Content-Type": "application/json",
        CodigoAplicacion: (this.headers.CodigoAplicacion || "").toString(),
        CodigoPlataforma: (this.headers.CodigoPlataforma || "").toString(),
        SistemaOperativo: (this.headers.SistemaOperativo || "").toString(),
        DispositivoNavegador: (
          this.headers.DispositivoNavegador || ""
        ).toString(),
        DireccionIP: (this.headers.DireccionIP || "").toString(),
      };
      if (token) hdrs["Authorization"] = `Bearer ${token}`;

      const finalUrl = url || this.defaultCorreoProxyUrl;

      this.sending = true;
      this.lastResult = null;
      try {
        const res = await fetch(finalUrl, {
          method: "POST",
          headers: hdrs,
          body: JSON.stringify(payload),
        });
        const text = await res.text();
        let body = text;
        try {
          body = JSON.stringify(JSON.parse(text), null, 2);
        } catch (_) {
          // Si no es JSON, se muestra como texto.
        }

        this.lastResult = {
          ok: res.ok,
          status: res.status,
          body,
        };

        if (this.$toast) {
          if (res.ok) {
            this.$toast.success("Enviado. Revisa respuesta abajo.", {
              position: "top-right",
              max: 3,
            });
          } else {
            this.$toast.error("Error al enviar. Revisa respuesta abajo.", {
              position: "top-right",
              max: 3,
            });
          }
        }
      } catch (e) {
        this.lastResult = {
          ok: false,
          status: 0,
          body: e?.message || String(e),
        };
        if (this.$toast) {
          this.$toast.error("No se pudo enviar (network/CORS).", {
            position: "top-right",
            max: 3,
          });
        }
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>

<style scoped>
.form-label {
  margin-top: 10px;
  font-size: 13px;
  font-weight: 600;
}
</style>
